module.exports = __webpack_public_path__ + "assets/img/hefei.0a078e30.png";